module.exports = __webpack_public_path__ + "static/media/project-thumbnail17.35a0da6b.jpg";